// @ts-nocheck
import { useActiveProfile } from '@/hooks/useActiveProfile';
import { useAdminImpersonation } from '@/contexts/AdminImpersonationContext';
import { useParentEditPermissions } from '@/hooks/useParentEditPermissions';
import { useAuth } from '@/contexts/AuthContext';

export interface ProfileEditPermissions {
  canEdit: boolean;
  canEditProfile: boolean;
  canEditAcademic: boolean;
  canEditAthletic: boolean;
  canEditExperiences: boolean;
  canEditPress: boolean;
  canEditSocialMedia: boolean;
  canEditPreferences: boolean;
  isAdmin: boolean;
  isParentEditing: boolean;
  isOwner: boolean;
}

export const useProfileEditPermissions = () => {
  const { user } = useAuth();
  const { profile, isImpersonating } = useActiveProfile();
  const { isImpersonating: adminImpersonating, impersonatedProfile } = useAdminImpersonation();
  const { canEdit: parentCanEdit } = useParentEditPermissions();

  // Get the original admin profile for role checking
  const { profile: originalProfile } = useAuth();

  console.log('🔑 useProfileEditPermissions:', {
    isImpersonating,
    adminImpersonating,
    originalProfileRole: originalProfile?.role,
    currentProfileRole: profile?.role,
    impersonatedProfileId: impersonatedProfile?.id,
    parentCanEdit
  });

  // Check if admin is impersonating
  if (adminImpersonating && originalProfile?.role === 'admin') {
    console.log('🔑 Admin impersonation detected - granting full edit permissions');
    return {
      canEdit: true,
      canEditProfile: true,
      canEditAcademic: true,
      canEditAthletic: true,
      canEditExperiences: true,
      canEditPress: true,
      canEditSocialMedia: true,
      canEditPreferences: true,
      isAdmin: true,
      isParentEditing: false,
      isOwner: false
    };
  }

  // Check if user owns this profile
  const isOwner = user?.id === profile?.user_id;

  // Check if parent has edit permissions
  const isParentEditing = parentCanEdit && !isOwner;

  // Default permissions for profile owners
  if (isOwner) {
    return {
      canEdit: true,
      canEditProfile: true,
      canEditAcademic: true,
      canEditAthletic: true,
      canEditExperiences: true,
      canEditPress: true,
      canEditSocialMedia: true,
      canEditPreferences: true,
      isAdmin: originalProfile?.role === 'admin',
      isParentEditing: false,
      isOwner: true
    };
  }

  // Parent editing permissions (limited)
  if (isParentEditing) {
    return {
      canEdit: true,
      canEditProfile: true,
      canEditAcademic: true,
      canEditAthletic: true,
      canEditExperiences: true,
      canEditPress: false, // Parents might not edit press
      canEditSocialMedia: false, // Parents might not edit social media
      canEditPreferences: false, // Parents might not edit recruiting preferences
      isAdmin: false,
      isParentEditing: true,
      isOwner: false
    };
  }

  // Default: no edit permissions
  return {
    canEdit: false,
    canEditProfile: false,
    canEditAcademic: false,
    canEditAthletic: false,
    canEditExperiences: false,
    canEditPress: false,
    canEditSocialMedia: false,
    canEditPreferences: false,
    isAdmin: false,
    isParentEditing: false,
    isOwner: false
  };
};